import useModal from '../../../useModal';
import UseContext from '../../../../../hooks/useContext';
import Modalheader from '../../../components/header';
import React, { useEffect, useState } from 'react';
import ModalFooter from '../../../components/footer';
import Button from '../../../../button';
import ModalBody from '../../../components/body';
import ApiDatabase from '../../../../../server';
import { toast } from 'react-toastify';

const ModalHolidayHoursCompany = () => {
  const { toggle } = useModal();
  const { modalData, setModalDataReturn } = UseContext();
  const [isLoading, setIsLoading] = useState(false);
  const [isWaiting, setIsWaiting] = useState(false);
  const [isWaitingBonusList, setIsWaitingBonusList] = useState(false);
  const [holidayBonus, setHolidayBonus] = useState(null);
  const [isActive, setIsActive] = useState(false);

  const token = localStorage.getItem('xsrfToken');

  const handleSubmit = () => {
    if (modalData?.idCompany && holidayBonus) {
      setIsLoading(true);
      const increase = isActive ? holidayBonus.value : null;
      ApiDatabase.postHolidayHoursCompany(
        { token, idCompany: modalData?.idCompany, increase },
        (data) => {
          setIsLoading(false);
          toast.success(
            isActive
              ? 'La majoration des heures de jours fériés a été activée'
              : 'La majoration des heures de jours fériés a été désactivée'
          );
          setModalDataReturn({
            type: 'holiday_hours_updated',
            increase,
          });
          toggle();
        },
        (err) => {
          if (err.name !== 'CanceledError') {
            console.log(err);
            setIsLoading(false);
          }
        }
      );
    }
  };

  useEffect(() => {
    if (!modalData?.idCompany) return;

    setIsWaitingBonusList(true);
    ApiDatabase.getBonusListCompany(
      { token, idCompany: modalData.idCompany },
      (data) => {
        // Trouver le bonus "HEURES JOURS FERIES TRAVAILLES"
        const holidayBonusFound = data.bonusList.find(
          (bonus) => bonus.name && bonus.name.includes('HEURES JOURS FERIES TRAVAILLES')
        );
        if (holidayBonusFound) {
          setHolidayBonus({
            value: holidayBonusFound._id,
            label: holidayBonusFound.name,
          });
        }
        setIsWaitingBonusList(false);
      },
      (err) => {
        if (err.name !== 'CanceledError') {
          console.error(err);
          setIsWaitingBonusList(false);
        }
      }
    );

    setIsWaiting(true);
    ApiDatabase.getHolidayHoursCompany(
      { token, idCompany: modalData.idCompany },
      (data) => {
        setIsActive(!!data.holidayHours);
        // Si holidayHoursDetails est disponible, mettre à jour le bonus
        if (data.holidayHoursDetails && !holidayBonus) {
          setHolidayBonus({
            value: data.holidayHoursDetails._id,
            label: data.holidayHoursDetails.name,
          });
        }
        setIsWaiting(false);
      },
      (err) => {
        if (err.name !== 'CanceledError') {
          console.error(err);
          setIsWaiting(false);
        }
      }
    );
  }, [modalData?.idCompany]);

  return (
    <>
      <Modalheader hide={toggle} hideShow={true}>
        Heures jours fériés travaillés
      </Modalheader>
      <ModalBody>
        <div className="flex flex-col gap-2.5 text-sm">
          {isWaiting || isWaitingBonusList ? (
            <div className={'animate-pulse'}>
              <div className={'h-16 bg-gray-200 rounded w-full'}></div>
            </div>
          ) : (
            <>
              <div className="p-4 border rounded">
                <div className="text-sm text-gray-700">
                  {isActive
                    ? 'La majoration des heures de jours fériés est actuellement activée.'
                    : 'La majoration des heures de jours fériés est actuellement désactivée.'}
                </div>
                {holidayBonus && (
                  <div className="text-xs text-gray-500 mt-2">
                    Bonus: {holidayBonus.label}
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </ModalBody>
      <ModalFooter>
        {isLoading ? (
          <>
            <Button size={'LG'} color={'SECONDARY'}>
              Annuler
            </Button>
            <Button size={'LG'} color={'DISABLED'}>
              Confirmation ...
            </Button>
          </>
        ) : (
          <>
            <Button size={'LG'} color={'SECONDARY'} onClick={toggle}>
              Annuler
            </Button>
            <Button size={'LG'} color={'PRIMARY'} onClick={handleSubmit}>
              Confirmer
            </Button>
          </>
        )}
      </ModalFooter>
    </>
  );
};

export default ModalHolidayHoursCompany;
